import React, { useState } from 'react';
interface AvatarProps {
  src?: string;
  alt: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fallback?: string;
  className?: string;
}
export function Avatar({
  src,
  alt,
  size = 'md',
  fallback,
  className = ''
}: AvatarProps) {
  const sizes = {
    sm: 'h-8 w-8 text-xs',
    md: 'h-10 w-10 text-sm',
    lg: 'h-14 w-14 text-base',
    xl: 'h-20 w-20 text-lg'
  };
  const [error, setError] = useState(false);
  return <div className={`relative inline-block rounded-full overflow-hidden bg-gray-200 ${sizes[size]} ${className}`} data-id="element-202">
      {src && !error ? <img src={src} alt={alt} className="h-full w-full object-cover" onError={() => setError(true)} data-id="element-203" /> : <div className="h-full w-full flex items-center justify-center bg-[var(--secondary)] text-white font-medium" data-id="element-204">
          {fallback || alt.charAt(0).toUpperCase()}
        </div>}
    </div>;
}